

    import {Component, Vue, Prop} from 'vue-property-decorator'
    import Usermenu from "@/components/usermenu/index.vue";


    @Component({
        components: {
            Usermenu
        }
    })

    export default class PageUsermenu extends Vue {

        @Prop() private id!: string;

        get minHeight(){

            return window.innerHeight + 'px';
        }
    }


